import moment from 'moment';

export function formatDateToMMDDYYYY(date) {
  if (!date || Number.isNaN(new Date(date).getTime())) {
    return null;
  }

  const formattedDate = new Date(date);
  const month = String(formattedDate.getMonth() + 1).padStart(2, '0');
  const day = String(formattedDate.getDate()).padStart(2, '0');
  const year = formattedDate.getFullYear();

  return `${month}/${day}/${year}`;
}

export function formateDateToDDMMYYYYHHMM(inputDate) {
  if (!inputDate || Number.isNaN(new Date(inputDate).getTime())) {
    return null;
  }

  const date = new Date(inputDate);
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');

  return `${day}/${month}/${year} ${hours}:${minutes}`;
}

export function formatToCurrentDateTime(inputDate) {
  if (!inputDate || Number.isNaN(new Date(inputDate).getTime())) {
    return null;
  }

  const date = new Date(inputDate);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

export function formatToYYYYMMDD(input) {
  if (!input || Number.isNaN(new Date(input).getTime())) {
    return null;
  }

  const dateObject = new Date(input);
  const formattedDate = dateObject.toLocaleDateString('en-GB', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });

  return formattedDate;
}

export function formatToLocalDateTime(inputTime) {
  if (!inputTime || Number.isNaN(new Date(inputTime + 'Z').getTime())) {
    return null;
  }

  const dateTime = new Date(inputTime + 'Z');
  const options = {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  };

  return dateTime.toLocaleDateString('en-IN', options);
}

export const convertUTCToLocal = (date, format = 'MM/DD/YYYY') => {
  if (!date || Number.isNaN(new Date(date).getTime())) {
    return null;
  }
  
  const localTime = moment.utc(date).toDate();
  return moment(localTime).format(format);
};

export const convertUTCDate = (date, format = 'MM/DD/YYYY') => {
  if (!date || Number.isNaN(new Date(date).getTime())) {
    return null;
  }

  const d = new Date();
  const dateWithTime = new Date(moment(date, 'MM-DD-YYYY').format('MM/DD/YYYY') + ' ' + d.getHours() + ':' + d.getMinutes());
  
  return moment(new Date(dateWithTime)).utc().format(format);
};